import { inject, injectable } from "@launchtray/tsyringe-async";
import { SceneManager } from "scene-manager";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { Scales } from "../../../../canvas/CanvasScaler";
import { Sprite } from "@pixi/sprite";
import { InjectableInterfaces } from "../../../composition/InjectableInterfaces";
import { SceneManagerWrapper } from "../../../SceneManagerWrapper";
import { Texture } from "@pixi/core";

@injectable()
export class FullscreenBackground extends Sprite {
    private readonly canvasScaler: ICanvasScaler;

    public constructor(
        sceneManager: SceneManager,
        @inject(InjectableInterfaces.ICanvasScaler) canvasScaler: ICanvasScaler
    ) {
        super();
        this.canvasScaler = canvasScaler;
        (sceneManager as SceneManagerWrapper).backgroundLayer.addChild(this);
        this.canvasScaler.onResize.add(this.onResize, this);
    }

    public updateImage(texture: Texture): void {
        this.texture = texture;
        this.layout(this.canvasScaler.browserWidth, this.canvasScaler.browserHeight);
    }

    private onResize(_scales: Scales): void {
        this.layout(this.canvasScaler.browserWidth, this.canvasScaler.browserHeight);
    }

    private layout(width: number, _height: number): void {
        this.height = window.innerHeight;
        this.scale.x = this.scale.y;
        this.position.x = (width - this.width) * 0.5;
    }
}